import { render, staticRenderFns } from "./ButtonWrapperSmall.vue?vue&type=template&id=0bdb7b61&scoped=true"
import script from "./ButtonWrapperSmall.vue?vue&type=script&lang=js"
export * from "./ButtonWrapperSmall.vue?vue&type=script&lang=js"
import style0 from "./ButtonWrapperSmall.vue?vue&type=style&index=0&id=0bdb7b61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdb7b61",
  null
  
)

export default component.exports